import { Twitter } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';
import { Link } from 'react-router-dom';
import { Separator } from '@/components/ui/separator';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const isMobile = useIsMobile();
  
  return (
    <footer className="bg-secondary/70 py-10 sm:py-12 md:py-16 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto flex justify-center">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 w-full">
          {/* Company Info - Centered on both mobile and desktop */}
          <div className="md:col-span-1 flex flex-col items-center">
            <div className="flex items-center space-x-2 text-lg sm:text-xl font-medium mb-4">
              <span className="bg-primary text-primary-foreground rounded-md p-1 text-xs sm:text-sm">KT</span>
              <span>Keplerion Tech</span>
            </div>
            <p className="text-sm text-muted-foreground mb-4 max-w-md text-center">
              Building intelligent software solutions for tomorrow's challenges.
            </p>
            {/*<div className="flex space-x-4 mb-6 md:mb-0">*/}
            {/*  <span className="text-muted-foreground transition-colors" aria-label="Twitter">*/}
            {/*    <Twitter size={isMobile ? 18 : 20} />*/}
            {/*  </span>*/}
            {/*</div>*/}
          </div>
          
          {/* Services & Company Links - Centered on both mobile and desktop */}
          <div className="grid grid-cols-2 gap-8 md:col-span-2">
            <div className="flex flex-col items-center">
              <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Services</h4>
              <ul className="space-y-2 text-center">
                <li><span className="text-xs sm:text-sm text-muted-foreground">Custom Software</span></li>
                <li><span className="text-xs sm:text-sm text-muted-foreground">Web Development</span></li>
                <li><span className="text-xs sm:text-sm text-muted-foreground">AI Solutions</span></li>
              </ul>
            </div>
            
            <div className="flex flex-col items-center">
              <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">Company</h4>
              <ul className="space-y-2 text-center">
                <li><Link to="/about" className="text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors hover-underline">About Us</Link></li>
                <li><Link to="/team" className="text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors hover-underline">Our Team</Link></li>
                <li><Link to="/portfolio" className="text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors hover-underline">Portfolio</Link></li>
                <li><Link to="/contact" className="text-xs sm:text-sm text-muted-foreground hover:text-foreground transition-colors hover-underline">Contact</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex justify-center mt-8">
        <div className="max-w-5xl w-full">
          <Separator className="mb-4" />
          <p className="text-center text-muted-foreground text-xs sm:text-sm">
            &copy; {currentYear} Keplerion Tech. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
